/**
 * Language control in `LandingNewNav` — reference height for the CTA row.
 */
export const LANDING_NEW_NAV_CTA_CONTROL_HEIGHT = 40

/**
 * Signed-in pill + Open app / Get started — 2px shorter than the language
 * control (1px inset top and bottom) so all three align visually.
 */
export const LANDING_NEW_NAV_CTA_LEFT_CONTROL_HEIGHT = LANDING_NEW_NAV_CTA_CONTROL_HEIGHT - 2
